import { TFunction } from '@psyomics/ui-common';
import { SurveyJs } from '@psyomics/ui-components';

import {
  uploadSurveyAttachment,
  useDeleteSurveyAttachment,
  useGetSurveyAttachmentDownloadUrl,
} from '../../survey-responses/hooks/use-survey-attachments';

type DeleteSurveyAttachment = ReturnType<typeof useDeleteSurveyAttachment>[1];
type GetSurveyAttachmentDownloadUrl = ReturnType<typeof useGetSurveyAttachmentDownloadUrl>;

type CreateSurveyAttachmentHandlersProps = {
  deleteSurveyAttachment: DeleteSurveyAttachment;
  getSurveyAttachmentDownloadUrl: GetSurveyAttachmentDownloadUrl;
  patientApiUrl: string;
  surveyResponseId: string;
  t: TFunction;
};

const createSurveyAttachmentHandlers = ({
  deleteSurveyAttachment,
  getSurveyAttachmentDownloadUrl,
  patientApiUrl,
  surveyResponseId,
  t,
}: CreateSurveyAttachmentHandlersProps) =>
  SurveyJs.createSurveyAttachmentHandlers({
    deleteAttachment: async (attachmentId) => {
      const result = await deleteSurveyAttachment({ input: { attachmentId } });
      if (result.error) {
        throw result.error;
      }
    },
    getDownloadUrl: async (attachmentId) => {
      const result = await getSurveyAttachmentDownloadUrl({ input: { attachmentId } });
      return result.data?.getSurveyAttachmentDownloadUrl.url;
    },
    t,
    uploadFile: (file, questionName) => uploadSurveyAttachment({ file, patientApiUrl, questionName, surveyResponseId }),
  });

export { createSurveyAttachmentHandlers };
